
import { defineComponent } from 'vue';

import Hero from '@/components/Hero.vue';

export default defineComponent({
  components: { Hero },
  data() {
    return {
      hero: 'resultaat-915109450.webp',
    };
  },
});
